import { Component, OnInit, ElementRef } from '@angular/core';
import { Meta } from '../common/seo.service';
import { ActivatedRoute } from '@angular/router';
import { FillerService } from '../common/Service_tnFiller';
import * as myGlobals from '../global';
import { SafeResourceUrl, 
         DomSanitizer } from '@angular/platform-browser';
import { SiteConfigurationService } from '../common/site-configuration.service'; 

@Component({
  selector: 'app-newsdetail',
  templateUrl: '../themes/default/html/newsdetail.component.html',
  styleUrls: ['../themes/default/css/newsdetail.component.scss']
})
export class NewsdetailComponent implements OnInit {

  DetailId: any; 
  News: any = {};
  ImagesList= [];
  _mySettings: any; 
  FirstImage: any;

  showgallery: boolean = false;

  constructor(private myMeta: Meta, private route: ActivatedRoute, private filler: FillerService,public sanitizer: DomSanitizer, private mySettings: SiteConfigurationService ) {    
    
    this._mySettings = mySettings.getFullConfig();

    this.route.params.subscribe(params => {
        this.DetailId = params["id"];
    });

    var payload = {};
    
    payload = JSON.stringify({id: this.DetailId, categoryId: 0, uiCulture: "it"});

    new Promise((resolve, reject) => {
      this.filler.Get_News(payload).subscribe(
          data => {
            this.News = Object.assign([], data)
            resolve(true);
          }, err => { console.log(err) }
        );
    }).then(
      e => {
        myMeta.setTitle(this.News.Title);

        // aggiorna la data
        this.News.Date = this.News.Date * 1000;

        this.ImagesList = JSON.parse(this.News.Images);
        
        try {
          for (let singleImage of this.ImagesList) {
            singleImage.url == "" ? singleImage.url = myGlobals.apiBasePath + this._mySettings.e400.images.noAdsImagePlaceHolder : singleImage.url = myGlobals.apiBasePath +  singleImage.url;        
            this.showgallery = true;
          } 
        } catch (e) { }
        
        try {
          this.FirstImage = this.ImagesList[0].url;
        } catch (e) {
          this.FirstImage = myGlobals.apiBasePath + this._mySettings.e400.images.noAdsImagePlaceHolder;
        }
        
        if (this.FirstImage == "") { this.FirstImage = myGlobals.apiBasePath + this._mySettings.e400.images.noAdsImagePlaceHolder; }

      }
    );

  }

  ngOnInit() {
    
  }

}



// WEBPACK FOOTER //
// A:/Work/Siti/Volpe2/src/app/newsdetail/newsdetail.component.ts